export default __webpack_public_path__ + "static/media/Geta_Shop.dd50864e.jpg";